export default __webpack_public_path__ + "static/media/suika.28409769.webp";